import { asset } from "../lib/api";

export const isImgAvatar = (a) => /^(https?:|\/api\/)/.test(a || "");

// Child avatar: emoji text, or a picture (zodiac art or uploaded photo).
export const Avatar = ({ value, size = "w-full h-full" }) =>
  isImgAvatar(value) ? <img src={asset(value)} alt="" className={`${size} object-cover rounded-full`} /> : <>{value}</>;
